import { render } from "./StandardStaticHeader.vue?vue&type=template&id=2d26b5ff&scoped=true&ts=true"
import script from "./StandardStaticHeader.vue?vue&type=script&lang=ts"
export * from "./StandardStaticHeader.vue?vue&type=script&lang=ts"

import "./StandardStaticHeader.vue?vue&type=style&index=0&id=2d26b5ff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d26b5ff"]])

export default __exports__